// @flow

import moment from "moment"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"
import { cuckooEvents } from "@kiwicom/frontend-common/consts/enums"
import BookingPendingRefund from "@kiwicom/frontend-app/scripts/containers/mutable/BookingPendingRefund"

import mapperRefundMethods from "./mapperRefundMethods"
import type { PendingRefund } from "mmb/records/bookingInput"
import { PENDING_REFUND_REASONS } from "../../../scenes/BookingPendingRefund/consts/constants"

// pending refund reasons that we expect from BE
const expectedReasons = Object.values(PENDING_REFUND_REASONS)

// modal Pending refunds is displayed only for following pending refund reasons
const displayedReasons = [
  PENDING_REFUND_REASONS.TECHNICAL_ISSUE,
  PENDING_REFUND_REASONS.GENERAL,
  PENDING_REFUND_REASONS.PRICE_CHANGED,
  PENDING_REFUND_REASONS.SOLD_OUT,
  PENDING_REFUND_REASONS.DUPLICATES,
  PENDING_REFUND_REASONS.SCHEDULE_CHANGE,
]

export default function(pendingRefunds: Array<PendingRefund>): Array<BookingPendingRefund> {
  return pendingRefunds
    .filter(x =>
      expectedReasons.includes(x.reason)
        ? displayedReasons.includes(x.reason)
        : cuckoo.track(cuckooEvents.MMB_UNKNOWN_PENDING_REFUND_REASON, { reason: x.reason }),
    )
    .map(
      x =>
        new BookingPendingRefund({
          id: x.id,
          created: x.created * 1000,
          updated: x.updated * 1000,
          status: x.status,
          reason: x.reason,
          abid: x.abid,
          amount: x.amount,
          currency: x.currency.toLocaleLowerCase(),
          refundTo: x.refund_to,
          autoRefundAt: moment.utc(x.auto_refund_at * 1000, "x").local(),
          refundMethods: mapperRefundMethods(x.refund_methods),
        }),
    )
}
